import React from 'react';

import { PopoverEx as SparkPopover } from '../../../../ui/sabre-spark-react-ex';
import {SketchPicker} from 'react-color';
import { toHex } from '../utils/colorUtils';
class ColorRow extends React.Component {
    constructor(props) {
        super(props);
        this.pickWithEyeDropper = this.pickWithEyeDropper.bind(this);
    }

    async pickWithEyeDropper() {
        if (typeof window !== 'undefined' && window.EyeDropper) {
            try {
                const eyeDropper = new EyeDropper();
                const result = await eyeDropper.open();
                this.props.onInputPickerChange(this.props.row.key, { hex: result.sRGBHex });
            } catch (e) {
                console.error("Eye dropper failed:", e);
            }
        }
    }

    render() {
        const { row, value, onInputColorChange, onInputPickerChange } = this.props;
        const hasEye = (typeof window !== 'undefined' && window.EyeDropper);
        const isInvalid = !CSS.supports('color', value);

        return (
            <div className={'in-context-color-container'} key={row.key}>
                <div className="in-context-color-row">
                    <div className={'in-context-color-container'} key={row.key}>
                        <div className="in-context-color-label">
                            {row.label}
                        </div>
                        <SparkPopover
                            anchorX="right"
                            toggleEl={

                                <div className="in-context-color-row">
                                    <label className="in-context-color-input" style={{ backgroundColor: value }}>
                                    </label>
                                </div>
                            }
                        >
                            <SketchPicker styles={{
                                default: {
                                    picker: {
                                        boxShadow: 'none',
                                        border: 'none',
                                        padding: 0,
                                    },
                                },
                            }} color={toHex(value)} presetColors={[]}  width={250} onChange={(e) => onInputPickerChange(row.key, e)} />
                            {hasEye ? (
                                <div className="color-picker-eyedropper">
                                    <button
                                        type="button"
                                        title="Pick from screen"
                                        className="in-context-menu-button"
                                        onClick={this.pickWithEyeDropper}
                                    >
                                        <span className="spark-icon spark-icon--md spark-icon-design-dropper"></span>
                                    </button>
                                </div>

                            ) : null}
                        </SparkPopover>
                        <input
                            type="text"
                            className="in-context-color-hex-input"
                            value={value}
                            aria-invalid={isInvalid}
                            onChange={e => onInputColorChange(row.key, e)}
                        />
                        {isInvalid && (
                            <sub className="in-context-color-error">
                                Enter a valid color format
                            </sub>
                        )}
                    </div>
                </div>

            </div>
        );
    }
}

const ColorGroup = ({ group, prefixKey, open, toggle, values, onInputColorChange, onInputPickerChange }) => {
    const k = (prefixKey || 'root/colors') + '/' + group.key;
    const isOpen = !!open[k];
    return (
        <div key={group.key} className="in-context-color-group">
            <div className="in-context-color-group-head">
                <div className="in-context-color-group-title">{group.title}</div>
                <button
                    type="button"
                    className="in-context-toggle"
                    onClick={() => toggle(k)}
                    aria-label={isOpen ? 'Collapse' : 'Expand'}
                >
                    {isOpen ? '–' : '+'}
                </button>
            </div>
            <div className={'in-context-color-group-body' + (isOpen ? ' open' : '')}>
                {group.rows.map(row => (
                    <ColorRow
                        key={row.key}
                        row={row}
                        value={values[row.key] || ''}
                        onInputColorChange={onInputColorChange}
                        onInputPickerChange={onInputPickerChange}
                    />
                ))}
            </div>
        </div>
    );
};

export const ColorPanel = ({ item, prefix, open, values, toggle, updateValue, keyFor }) => {
    const key = keyFor(prefix, item);
    const isOpen = !!open[key];

    const onInputColorChange = (row, e) => {
        const color =  e.target.value;
        updateValue(row, color);
    };
    const onInputPickerChange = (row, color) => {
        const isCssColor = CSS.supports('color', color.hex);
        if(isCssColor) {
            updateValue(row, color.hex);
        }
    };


    return (
        <li key={key} className="in-context-menu-item is-selected">
            <div className="in-context-menu-label">
                <button
                    type="button"
                    className="in-context-menu-button"
                    onClick={() => toggle(key)}
                >
                    {item.name}
                </button>
                <button
                    type="button"
                    className="in-context-toggle"
                    onClick={() => toggle(key)}
                    aria-label={isOpen ? 'Collapse' : 'Expand'}
                >
                    {isOpen ?
                        <i className="spark-icon-arrow-chevron-down spark-icon--fill" /> :
                        <i className="spark-icon-arrow-chevron-up spark-icon--fill" />
                    }
                </button>
            </div>

            <div className={'in-context-submenu' + (isOpen ? ' open' : '')}>
                <div className="in-context-color-panel">
                    {item.groups.map((group) => (
                        <ColorGroup
                            key={group.key}
                            group={group}
                            prefixKey={key}
                            open={open}
                            toggle={toggle}
                            values={values}
                            onInputColorChange={onInputColorChange}
                            onInputPickerChange={onInputPickerChange}
                        />
                    ))}
                </div>
            </div>
        </li>
    );
};


// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/panels/ColorPanel.js